module.exports = __webpack_public_path__ + "img/JoinAHomeFresh2.12925821.png";